<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/sppd">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">
                {{ "Manifest PD Activity Report".toUpperCase() }}
              </h4>
              <small>{{ data.manifest.no_pdlk }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    @click="handlePrint"
                    type="dashed"
                    icon="printer"
                    block
                    class="m-display-block"
                    :loading="printLoad.manifest"
                    >Manifest</a-button
                  >
                </li>
                <li v-if="getAuth.username == data.manifest.tlc_pembuat">
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.last_status == 'Revised' &&
                          getAuth.username == data.manifest.tlc_pembuat
                        )
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="
                        !(
                          data.last_status == 'Revised' &&
                          getAuth.username == data.manifest.tlc_pembuat
                        )
                      "
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Cost Center</span>
                  <span class="m-list-desc">{{
                    data.manifest.kode_project
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User</span>
                  <span class="m-list-desc">{{
                    data.manifest.user_pembuat
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Assignee</span>
                  <ul
                    v-for="assignee in data.assignee"
                    :key="assignee.user_assignee"
                  >
                    <li class="m-list-desc">{{ assignee.user_assignee }}</li>
                  </ul>
                </li>
                <li>
                  <span class="m-list-title" for
                    >Busines Trip (PD) Schedule</span
                  >
                  <span class="m-list-desc">{{
                    data.manifest.jadwal_dinas
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Work Unit</span>
                  <span class="m-list-desc">{{ data.manifest.satker }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Location</span>
                  <span class="m-list-desc">{{ data.manifest.lokasi }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Activity Details</h4>
              </div>
              <a-list
                itemLayout="vertical"
                :dataSource="data.detail_kegiatan"
                :pagination="pagination"
              >
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title" style="display: flex; width: 100%; justify-content: space-between; align-items: center;">
                      <span>{{ item.tanggal }}</span>
                      <div style="display: flex; flex-direction: column; gap: 4px;">
                        <a-tag v-if="item.type" color="green">{{ typeDescription(item.type) }}</a-tag>
                        <a-button v-if="edit_kurs_action && item.type == 'LN'" icon="edit" size="small" :type="severity(item.kurs)" @click="showEditKursModal(item)">
                          Edit Kurs
                        </a-button>
                      </div>
                    </div>
                    <div slot="description" class="margin-remove">
                      <div class="m-display-flex">
                          <span>{{ arraytoText(item.pelaksana) }}</span>
                        </div>
                      <div class="m-display-flex">
                        <span>{{ item.kegiatan }}</span>
                      </div>
                      <div class="m-display-flex">
                        <span>{{ item.hasil }}</span>
                      </div>
                      <div v-if="item.type == 'LN'" class="m-display-flex">
                        <span>Kurs : {{ formatCurrency("IDR", Number(item.kurs)) }}</span>
                      </div>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            class="margin-top"
            :loading="loading"
            v-if="data.jenis !== 'Manifest' && !getScreen"
          >
            <div slot="title">Manifest actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Action">
                <a-select
                  @change="changeAction"
                  showSearch
                  v-decorator="[
                    'aksi',
                    { rules: [{ required: true }] },
                  ]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  :disabled="buttonDisable"
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>

        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.manifest.user_pembuat }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{ data.manifest.tgl_buat }}</h4>
                    <span
                      class="m-text-small"
                      v-if="
                        data.manifest.catatan !== null ||
                        data.manifest.catatan !== ''
                      "
                      >Tidak Ada Catatan</span
                    >
                    <span class="m-text-small" v-else>{{
                      data.manifest.catatan
                    }}</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{ workflow.tanggal_aksi }}
                    </h4>
                    <span
                      class="m-text-small"
                      v-if="workflow.remark !== null || workflow.remark !== ''"
                      >{{ workflow.remark }}</span
                    >
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleView(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="item.value_transaksi && item.rest_api !== 'sppds'"
                    >
                      <span class="m-timeline-title">{{
                        formatRupiah(item.value_transaksi)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Attachment</h4>
              </div>
              <a-list itemLayout="horizontal" :dataSource="data.lampiran">
                <Empty
                  v-if="
                    data.lampiran ? data.lampiran.length <= 0 : data.lampiran
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <h4 class="margin-remove">{{ item.deskripsi }}</h4>
                      <div>
                        <a-button
                          @click="handleViewBt(item)"
                          size="small"
                          type="default"
                          icon="eye"
                          >View</a-button
                        >
                      </div>
                    </div>
                    <img
                      class="m-image-icon"
                      slot="avatar"
                      src="@/assets/icon/pdf_ico.png"
                    />
                    <p slot="description">{{ item.nama_file }}</p>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>

      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" v-if="getScreen">
        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Manifest actions</h4>
            </div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Action">
                <a-select
                  showSearch
                  v-decorator="[
                    'aksi',
                    { rules: [{ required: true }], initialValue: 'Approved' },
                  ]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal v-model="kurs_modal_visible" title="Edit Kurs" @ok="handleOk">
      <a-form :form="formKurs">
        <a-form-item label="Nilai Kurs">
          <a-input-number id="inputNumber" :min="1"
          style="width: 100%;"
          class="w-full" 
            v-decorator="[
                'kurs',
                { rules: [{ required: true,message: 'Nilai kurs is required!' }], initialValue: edit_state.data.kurs > 0 ? edit_state.data.kurs : null }
            ]"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="handleCancelKurs">
          Cancel
        </a-button>
        <a-button key="submit" type="primary" :loading="kurs_submit" @click="handleOk">
          Submit
        </a-button>
      </template>
    </a-modal>

  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";

export default {
  name: "manifestLapPD",
  components: { Status },
  props: ["id"],
  mixins: [HandleRoute, CurrencyFormat],
  data() {
    return {
      loading: true,
      visibleHistory: false,
      data: {
        detail_kegiatan: [],
        dokumen_terkait: [],
        keuangan: {},
        manifest: {},
        status: [],
        history: [],
        mata_uang: "",
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      previewImage: "",
      printLoad: {
        manifest: false,
        cancel: false,
      },
      edit_kurs_action: false,
      kurs_modal_visible: false,
      edit_state: {
        data: {}
      },
      form_kurs: {
        kurs: 0
      },
      kurs_submit: false,
      statusAction: '',
      buttonDisable: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formKurs = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getStandartFormatDate",
    ]),
    initialList() {
      let output = [];
      this.data.detail_kegiatan.forEach((data) => {
        output.push({
          id_dtl: data.id_dtl,
          tgl: data.tanggal,
          kegiatan: data.kegiatan,
          hasil: data.hasil,
          pelaksana: data.pelaksana,
          type: data.type,
          kurs: data.kurs
        });
      });
      return { output };
    },

    totalKegiatan(){
      return this.data.detail_kegiatan
    },
  },
  methods: {
    moment,
    fetchManifest() {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "Lap_kegiatan_pd",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            manifest: response.data.header,
            assignee: response.data.assignee,
            detail_kegiatan: response.data.detail,
            lampiran: response.data.lampiran,
            status: response.data.status_app,
            last_status: response.data.last_status,
            history: response.data.notifikasi,
            dokumen_terkait: response.data.dokumen_terkait,
            jenis: response.data.jenis,
            aksi: response.data.aksi,
          };
          this.edit_kurs_action = response.data.edit_kurs_action
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle() {
      this.visibleHistory = !this.visibleHistory;
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        Axios({
          method: "post",
          url: this.$serviceUrl + "lap_kegiatan_pd/approval",
          processData: false,
          data: {
            id_manifest: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan ? values.catatan : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handleViewBt: function (item) {
      window.open(this.$serviceUrl + item.path_file, "_blank");
    },
    handlePrint(item) {
      this.printLoad.manifest = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "lap_kegiatan_pd/cek_manifest_LKPD",
        responseType: "blob",
        params: {
          tlc: this.getAuth.username,
          id_lkpd: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "pdlk",
        id_manifest: this.id,
        code_trans: this.data.manifest.no_pdlk,
        kode_project: this.data.manifest.kode_project,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "lapKegPdEdit",
        params: { id: this.id, type: "revised" },
      });
    },
    arraytoText(array) {
      let text = ""
      array.forEach((element) => {
        text += (text == "" ? element : "," + element);
      });
      return text;
    },

    severity(val){
      if(val <= 0){
        return 'danger'
      }else {
        return 'primary'
      }
    },

    typeDescription(type){
      const map = {
        DN: 'Dalam Negeri',
        LN: 'Luar Negeri'
      }
      return map[type] || ''
    },

    showEditKursModal(val){
      console.log(val);
      
      this.kurs_modal_visible = true
      this.edit_state.data = val
    },

    rupiahFormatter(value) {
      if (value === undefined || value === null || value === '') return ''
      const [intPart, decimalPart] = String(value)
        .replace(/[^0-9.,]/g, '') // hanya angka, koma, titik
        .replace(',', '.') // ubah koma ke titik biar konsisten
        .split('.')

      // format bagian ribuan
      const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      // gabung kembali dengan bagian desimal (kalau ada)
      return decimalPart
        ? `Rp ${formattedInt},${decimalPart}`
        : `Rp ${formattedInt}`
    },

    rupiahParser(displayValue) {
      if (!displayValue && displayValue !== 0) return undefined
      const clean = String(displayValue)
        .replace(/[^0-9,.-]/g, '') // buang selain angka, koma, titik, minus
        .replace(/\./g, '') // hapus pemisah ribuan
        .replace(',', '.') // ubah koma ke titik biar bisa parseFloat
      const num = parseFloat(clean)
      return isNaN(num) ? undefined : num
    },

    handleOk(){
      this.kurs_submit = true
      this.formKurs.validateFields( async (err, values) => {
        if(err){
          this.kurs_submit = false
          return
        }

        await Axios({
          method: "post",
          url: this.$serviceUrl + "lap_kegiatan_pd/update_kurs",
          processData: false,
          data: {
            id_pdlk_dtl: this.edit_state.data.id_dtl,
            kurs: values.kurs
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        }).then((response) => {
          const dt = this.data.detail_kegiatan.find((a) => a.id_dtl == this.edit_state.data.id_dtl)
          dt.kurs = values.kurs

          this.displayMessageValue("success-other", "Data kurs berhasil disimpan");
          this.kurs_modal_visible = false
          this.formKurs.resetFields(['kurs'])
          this.kurs_submit = false
        }).catch((error) => {
          console.log(error);
          this.displayMessageValue("error", error.message);
          this.kurs_submit = false
        })

      })
    },

    handleCancelKurs(){
      this.kurs_modal_visible = false
      this.formKurs.resetFields(['kurs'])
    },

    changeAction(e){
      this.statusAction = e
      if(e == 'Revised'){
        this.buttonDisable = false
      }else if(e == 'Verified'){
        this.checkData(this.totalKegiatan)
      }
    },

    checkData(val){
      for (const item of val) {
        if (Number(item.kurs) <= 0 && item.type == 'LN') {
          return this.buttonDisable = true
        }
      }
      return this.buttonDisable = false
    },
  },
  mounted() {
    this.fetchManifest();
    Event.$on("confirmMessageReturn", this.handleAction);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleAction);
    Event.$off("handleCancel", this.canceltrans);
  },

  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },

    totalKegiatan: {
      handler(newVal, oldVal) {
        this.checkData(newVal)
      },
      deep: true
    }
  },
};
</script>

<style>
</style>